import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { UsersModule } from '../usersRolesManagement/usersManagement/users/users.module';
import { MyProfileComponent } from './my-profile.component';

@NgModule({
    imports: [SharedModule, UsersModule],
    declarations: [MyProfileComponent],
    entryComponents: [MyProfileComponent],
    exports: [MyProfileComponent]
})
export class MyProfileModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/my-profile/my-profile.module.ts